import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getSelfManagedTeamAvailableColumns, getRealEstatesShort } from './api';

export const path = '/self-managed-team/list';

const PageSelfManagedTeamList: React.FC = (props) => {
  const SelfManagedTeamList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getSelfManagedTeamAvailableColumns,
      realEstates: getRealEstatesShort,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <SelfManagedTeamList {...props} />;
};

export default PageSelfManagedTeamList;
